<template>
    <div
        class="flex items-center justify-center py-6"
        data-cy-item="loading-list-item"
    >
        <DLoader />
    </div>
</template>

<script setup>
    import { DLoader } from '@digistorm/spark'

    const props = defineProps({
        config: Object,
    })
</script>
